import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
    AppBar,
    Box,
    Toolbar,
    Typography,
    Container,
    Button,
    Link,
} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { DEFAULT_THEME, type ThemeColors } from '../../constants/themeDefaults';

const LoginNavbar = () => {
    const theme = DEFAULT_THEME;
    const location = useLocation();

    return (
        <AppBar 
            position="sticky" 
            sx={{ 
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}
        >
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    {/* Logo */}
                    <CalendarMonthIcon 
                        sx={{ 
                            display: 'flex', 
                            mr: 1,
                            color: theme.secondaryColor
                        }} 
                    />
                    <Typography
                        variant="h6"
                        noWrap
                        component={RouterLink}
                        to="/login"
                        sx={{
                            mr: 2,
                            display: 'flex',
                            fontWeight: 700,
                            color: theme.secondaryColor,
                            textDecoration: 'none',
                        }}
                    >
                        MindShare
                    </Typography>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default LoginNavbar; 